module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"generic":{"DEFAULT":"Quelle: Standardannahme, effektiver Wert unbekannt","GIS":"Quelle: GWR","MANUAL":"Quelle: Manuelle Eingabe"},"roofType":{"DEFAULT":"Quelle: Standardannahme, effektiver Wert unbekannt","GIS":"Quelle: GIS-Gebäudedaten","MANUAL":"Quelle: Manuelle Eingabe"},"component":{"AUTO":"Schätzung","MANUAL":"Manuell"}}}')
  delete Component.options._Ctor
}
